import { WatchlistMatches } from './WatchlistMatches';
import {
    SectionCard,
    SectionCardBody,
    SectionCardTitle,
    TagsAndWatchlistLayout,
} from './TagsList.StyledComponents';
import { TagsList } from './TagsList';

export const ApplicantTags = () => (
    <TagsAndWatchlistLayout>
        <SectionCard>
            <SectionCardTitle>Tags &amp; Signals</SectionCardTitle>
            <SectionCardBody>
                <TagsList />
            </SectionCardBody>
        </SectionCard>
        <SectionCard>
            <SectionCardTitle>Watchlist Checks</SectionCardTitle>
            <SectionCardBody>
                <WatchlistMatches />
            </SectionCardBody>
        </SectionCard>
    </TagsAndWatchlistLayout>
);
